import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceParent } from '../components/Workspace'

export const Route = createFileRoute('/challenge/$slug')({
  component: () => {
    const { slug } = Route.useParams()

    return <WorkspaceParent slug={slug} key={slug} />
  },
})
